import * as React from "react";
import type { SVGProps } from "react";
const SvgCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M2.4 1.993a1 1 0 0 0 0 2v-2m2.293 1 .965-.262a1 1 0 0 0-.965-.738zm3.725 13.755-.965.261a1 1 0 0 0 1.089.731zm11.463-1.433.124.992a1 1 0 0 0 .855-.79zm1.719-8.31.98.202a1 1 0 0 0-.98-1.202zm-15.82 0-.966.261zM2.4 2.993v1h2.293v-2H2.4zm6.018 13.755.124.992 11.463-1.433-.124-.992-.124-.992-11.463 1.433zm11.463-1.433.979.203 1.72-8.31-.98-.203-.98-.203-1.719 8.31zM4.693 2.993l-.966.261 1.087 4.012.965-.261.965-.262-1.086-4.012zm1.086 4.012-.965.261 2.639 9.743.965-.261.965-.262-2.639-9.743zm15.821 0v-1H5.78v2H21.6zM12 20.5h-1a.5.5 0 0 1-.5.5v2a2.5 2.5 0 0 0 2.5-2.5zM10.5 22v-1a.5.5 0 0 1-.5-.5H8a2.5 2.5 0 0 0 2.5 2.5zM9 20.5h1a.5.5 0 0 1 .5-.5v-2A2.5 2.5 0 0 0 8 20.5zm1.5-1.5v1a.5.5 0 0 1 .5.5h2a2.5 2.5 0 0 0-2.5-2.5zm9.5 1.5h-1a.5.5 0 0 1-.5.5v2a2.5 2.5 0 0 0 2.5-2.5zM18.5 22v-1a.5.5 0 0 1-.5-.5h-2a2.5 2.5 0 0 0 2.5 2.5zM17 20.5h1a.5.5 0 0 1 .5-.5v-2a2.5 2.5 0 0 0-2.5 2.5zm1.5-1.5v1a.5.5 0 0 1 .5.5h2a2.5 2.5 0 0 0-2.5-2.5z"
    />
  </svg>
);
export default SvgCart;
